// UserContext.js — shim de compatibilité → délègue vers AuthContext
// Les composants existants (Login, Profile, etc.) continuent de fonctionner sans modification.
import React from 'react';
import { useAuth, ROLES } from './AuthContext';

// No-op : AuthProvider est monté directement dans App.js
export const UserProvider = ({ children }) => <>{children}</>;

export const useUser = () => {
  const auth = useAuth();
  const isUserRole = auth.role === ROLES.CLIENT || auth.role === ROLES.DRIVER;

  return {
    user:            isUserRole ? auth.user : null,
    isAuthenticated: auth.isAuthenticated && isUserRole,
    loading:         auth.loading,
    login:           auth.login,
    logout:          auth.logout,
    updateUser:      auth.updateUser,
    isClient:        auth.isClient,
    userId:          auth.userId,
    userEmail:       auth.userEmail,
    // 🛒 C1 — RÉ-EXPORT des champs AuthContext oubliés par ce shim. `canUseCart` en particulier
    // était `undefined` → l'icône panier ne s'affichait JAMAIS dans le Header desktop (Header
    // lit useUser()). On expose aussi role/isGuest/hasRole/roles pour les autres consommateurs
    // du shim (Profile, Home, TrajetList, guards) qui pourraient en dépendre.
    canUseCart:      auth.canUseCart,
    role:            auth.role,
    roles:           auth.roles,
    isGuest:         auth.isGuest,
    hasRole:         auth.hasRole,
  };
};
